const properties = {
  productDowntimeEndDate: null //flag to turn on maintenance redirect. (Will redirect all qc app url to maintenance page)
}

export default properties
